<template>
    <div class="banner">
        <p class="banner__content">
            <b>
                Uus versioon 99mathist on saadaval!
                <br />
                Nüüd leiab platvormilt 20 teemat, klassi arengu raportid ja muud
                põnevat!
            </b>
            <br />
            Arendatud ESF meetme „Kaasaegse ja uuendusliku õppevara arendamine
            ja kasutuselevõtt“ raames.
        </p>
        <img
            src="/images/lp/banner-eu-image.svg"
            alt="europa-liit"
            class="banner__image"
        />
    </div>
</template>
<style lang="scss" scoped>
.banner {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    padding: 0 25px;

    @include mq($w-max-sm, max) {
        flex-direction: column;
    }

    &__content {
        font-style: normal;
        font-weight: normal;
        font-size: 1.25rem;
        line-height: 1.875rem;
        text-align: center;
        color: #000000;
        margin: 1.75rem auto 1.75rem 158px;
        width: calc(100% - 158px);

        @include mq($w-max-sm, max) {
            width: 100%;
            margin: 1.75rem auto;
            order: 2;
            font-size: 0.9rem;
            line-height: 1.4rem;
        }
    }

    &__image {
        @include mq($w-max-sm, max) {
            margin-top: 2rem;
            order: 1;
        }
    }
}
</style>
